import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
//import { injectIntl } from 'react-intl'
//import { strings } from '../messages/strings'

class SideBar extends React.Component {

  _buildPathName() {
    const { pathname } = this.props
    if(pathname === '') {
      return 'INTRO'
    } else if(pathname.includes('images')) {
      return 'IMAGES'
    } else {
      return pathname.toUpperCase()
    }
  }

  render() {
    return (
      <div style={{ 
        paddingTop: 50,
        float: 'left',
        height: 690,
        width: 184
      }}>
        <div style={{ paddingLeft: 20, color: '#333366', fontSize: 18,}}>MENU</div> 
        <div style={{backgroundColor: "#787f97", padding: '20px 0 60px 0', width: 108}}>
					<ul className='menu'>
						<li className='menu-link'>
							<Link className='link-alt' to={prefixLink('/')}>INTRO</Link>
						</li>
						<li className='menu-link'>
							<Link className='link-alt' to={prefixLink('/images/')}>IMAGES</Link>
						</li>
						<li className='menu-link'>
							<Link className='link-alt' to={prefixLink('/contact/')}>CONTACT</Link>
						</li>
						<li className='menu-link'>
							<Link className='link-alt' to={prefixLink('/profile/')}>PROFILE</Link>
						</li>
          </ul>
        </div>

        <div>
          <span style={{
						color: '#fff',
            marginTop: 8,
						padding: '20px 0',
						fontSize: 12,
						display: 'block',
						background: '#787f97',
						maxWidth: 108,
						textAlign: 'center',
						letterSpacing: 1,
						fontWeight: 700,
					}}>{ this._buildPathName() }</span>
        </div>
        <div style={{borderRight: '1px solid #ccccff', height: 188, width: 43}} />
        <div style={{fontSize: 10, color: '#1b1b37', paddingLeft: 8}}>
          &copy;2017 Lawrence Perlman
        </div>

      </div>
    )
  }
}

export default SideBar



// WEBPACK FOOTER //
// ../components/SideBar.js